<template>
    <div>
        <b-form-group class="centered-radios">
            <b-form-radio v-model="notGranted" name="some-radios" :value="true" :disabled="completed"><strong>Nu am primit</strong> alte ajutoare de stat sau finanțări nerambursabile.</b-form-radio>
            <b-form-radio v-model="notGranted" name="some-radios" :value="false" :disabled="completed"><strong>Am primit sau am solicitat</strong> următoarele ajutoare de stat sau finanțări nerambursabile</b-form-radio>
        </b-form-group>
        <hr v-if="!notGranted" class="mt-3 mb-4">

        <a v-if="!notGranted" class="add-button" style="margin-left: auto" @click="addFinance()">
            <p class="mr-3">Adaugă finanțare</p>
            <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
        </a>
        <validation-observer v-if="!notGranted" #default="{ invalid }" ref="fundingSent">
            <span class="display-none">{{ invalid }}</span>
            <div v-for="(asistenta, key) in fundings" :key="key" class="asistenta">
                <div class="asistenta-header" @click="asistenta.opened = !asistenta.opened">
                    <h3>{{ asistenta.title }}</h3>
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div class="actions-buttons">
                            <p class="action-badge" :class="asistenta.type === 'sent' ? 'sent-badge' : ''" @click.stop="asistenta.type = 'sent'">Primit</p>
                            <p class="action-badge" :class="asistenta.type === 'asked' ? 'asked-badge' : ''" @click.stop="asistenta.type = 'asked'">Solicitat</p>
                        </div>
                        <b-icon-chevron-down v-if="!asistenta.opened" font-scale="1.2" class="expand-icon"></b-icon-chevron-down>
                        <b-icon-chevron-up v-else font-scale="1.2" class="expand-icon"></b-icon-chevron-up>
                        <b-icon-x-circle-fill class="delete-icon" @click.stop="deleteFinance(key)"></b-icon-x-circle-fill>
                    </div>
                </div>
                <div v-show="asistenta.opened" class="asistenta-body">
                    <!-- TITLU - PRIMIT & SOLICITAT -->
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Titlu"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="asistenta.title"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <!-- INFO ÎNREGISTRARE - SOLICITAT -->
                    <validation-provider
                        v-if="asistenta.type === 'asked'"
                        #default="{ errors }"
                        rules="required"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Informații înregistrare solicitare"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="asistenta.infos"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <!-- VALOARE TOTALA / ELIGIBIL PROIECT - SOLICITAT -->
                    <div v-if="asistenta.type === 'asked'" class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Valoare totală proiect"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.total_project"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Eligibil proiect"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.eligible_project"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>

                    <!-- NR CONTRACT - PRIMIT -->
                    <validation-provider
                        v-if="asistenta.type === 'sent'"
                        #default="{ errors }"
                        rules="required"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Nr. înreg. contract"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="asistenta.contract_no"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <!-- DATĂ SEMNARE / INCEPERE / FINALIZARE - PRIMIT -->
                    <div v-if="asistenta.type === 'sent'" class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 30%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Dată semnare"
                                class="has-icon custom-responsive"
                            >
                                <b-form-datepicker
                                    v-model="asistenta.date_signed"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    placeholder="Selectează o dată"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 27%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Dată începere"
                                class="has-icon custom-responsive"
                            >
                                <b-form-datepicker
                                    v-model="asistenta.date_started"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    placeholder="Selectează o dată"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 25.6%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Dată finalizare"
                                class="has-icon custom-responsive"
                            >
                                <b-form-datepicker
                                    v-model="asistenta.date_end"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    placeholder="Selectează o dată"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>

                    <!-- VALOARE TOTALA / ELIGIBIL PROIECT - PRIMIT -->
                    <div v-if="asistenta.type === 'sent'" class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Valoare totală proiect"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.total_project"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Eligibil proiect"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.eligible_project"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>

                    <!-- ELIGIBIL BENEFICIAR / SPRIJIN BENEFICIAR - PRIMIT -->
                    <div v-if="asistenta.type === 'sent'" class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Eligibil beneficiar"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.eligible_ben"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Sprijin beneficiar"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.support_ben"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>

                    <!-- SURSE FINANTARE - PRIMIT -->
                    <validation-provider
                        v-if="asistenta.type === 'asked'"
                        #default="{ errors }"
                        rules="required"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Surse Financiare"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="asistenta.funding_source"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>

                    <!-- RAMBURSARE EFECTIVĂ / SURSE FINANȚARE - SOLICITAT -->
                    <div v-if="asistenta.type === 'sent'" class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input w-48"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Rambursare efectivă"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.cashback"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="second-input v-50"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Surse financiare"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.funding_source"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>

                    <!-- MONEDĂ / CURS DE SCHIMB / DATĂ CURS - PRIMIT & SOLICITAT -->
                    <div class="flex flex-end mb-1 modify-res">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 30%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="3"
                                content-cols-lg="9"
                                label="Monedă"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.currency"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 27%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Curs de schimb"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.currency_rate"
                                    type="number"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            style="width: 25.6%;"
                            class="w-32"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-lg="4"
                                content-cols-lg="8"
                                label="Dată curs"
                                class="has-icon custom-responsive"
                            >
                                <b-form-input
                                    v-model="asistenta.currency_date"
                                    type="text"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </div>
                </div>
            </div>
        </validation-observer>

        <hr class="mt-5">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BIconPlusCircleFill, BIconXCircleFill, BFormDatepicker, BIconChevronDown, BIconChevronUp, BFormCheckbox, BFormRadio } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import moment from 'moment'
    require('@/helpers/validations/validations');
    export default {
        components: {
            BForm, BFormInput, BFormGroup, BIconPlusCircleFill, BIconXCircleFill, BFormDatepicker, BIconChevronDown, BIconChevronUp, BFormCheckbox, BFormRadio, ValidationProvider, ValidationObserver
        },
        props: {
            m3GrantApplication: null,
            cui: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                completed: false,
                notGranted: false,
                fundingSent: [],
                fundingAsked: [],
                fundings: [],
            }
        },
        computed: {
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            },
            m3allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            cui: {
                handler: function () {
                    if(this.cui && (this.m3GrantApplication && this.m3GrantApplication.solicitant && ((this.m3GrantApplication.solicitant.fundingAsked && this.m3GrantApplication.solicitant.fundingAsked.length > 0) || (this.m3GrantApplication.solicitant.fundingSent && this.m3GrantApplication.solicitant.fundingSent.length > 0) || (this.m3GrantApplication.solicitant.fundings && this.m3GrantApplication.solicitant.fundings.length > 0)))) {
                        this.initializeFundings()
                    } else {
                        this.checkFinancings()
                    }
                }
            },
            m3GrantApplication: {
                handler: function () {
                    if(this.cui && (this.m3GrantApplication && this.m3GrantApplication.solicitant && ((this.m3GrantApplication.solicitant.fundingAsked && this.m3GrantApplication.solicitant.fundingAsked.length > 0) || (this.m3GrantApplication.solicitant.fundingSent && this.m3GrantApplication.solicitant.fundingSent.length > 0) || (this.m3GrantApplication.solicitant.fundings && this.m3GrantApplication.solicitant.fundings.length > 0)))) {
                        this.initializeFundings()
                    }
                }
            },
        },
        mounted() {
            this.initializeFundings()
        },
        methods: {
            initializeFundings() {
                if(this.m3GrantApplication && this.m3GrantApplication.solicitant && ((this.m3GrantApplication.solicitant.fundingAsked && this.m3GrantApplication.solicitant.fundingAsked.length > 0) || (this.m3GrantApplication.solicitant.fundingSent && this.m3GrantApplication.solicitant.fundingSent.length > 0) || (this.m3GrantApplication.solicitant.fundings && this.m3GrantApplication.solicitant.fundings.length > 0) || this.m3GrantApplication.solicitant.fundingNotGranted )) {
                    if(this.m3GrantApplication.solicitant.fundingSent.length > 0) {
                        this.m3GrantApplication.solicitant.fundingSent.forEach(finantare => {
                            this.fundings.push({
                                title: finantare.title,
                                infos: '',
                                contract_no: finantare.contract_no,
                                date_signed: finantare.date_signed,
                                date_started: finantare.date_started,
                                date_end: finantare.date_end,
                                total_project: finantare.total_project,
                                eligible_project: finantare.eligible_project,
                                eligible_ben: finantare.eligible_ben,
                                support_ben: finantare.support_ben,
                                cashback: finantare.cashback,
                                funding_source: finantare.funding_source,
                                currency: finantare.currency,
                                currency_rate: finantare.currency_rate,
                                currency_date: finantare.currency_date,
                                opened: false,
                                type: 'sent'
                            })
                        })
                        this.notGranted = false
                    }
                    if(this.m3GrantApplication.solicitant.fundingAsked.length > 0) {
                        this.m3GrantApplication.solicitant.fundingAsked.forEach(finantare => {
                            this.fundings.push({
                                title: finantare.title,
                                infos: finantare.infos,
                                contract_no: '',
                                date_signed: '',
                                date_started: '',
                                date_end: '',
                                total_project: finantare.total_project,
                                eligible_project: finantare.eligible_project,
                                eligible_ben: '',
                                support_ben: '',
                                cashback: '',
                                funding_source: finantare.funding_source,
                                currency: finantare.currency,
                                currency_rate: finantare.currency_rate,
                                currency_date: finantare.currency_date,
                                opened: false,
                                type: 'asked'
                            })
                        })
                        this.notGranted = false
                    }
                    if(this.m3GrantApplication.solicitant.fundings){
                        this.fundings = this.m3GrantApplication.solicitant.fundings
                        if(this.m3GrantApplication.solicitant.fundings.length > 0){
                            this.notGranted = false
                        }
                    }

                    this.fundings.forEach(funding => {
                        this.completed = moment(funding.date_started, "YYYY-MM-DD", true).isValid() && moment(funding.date_signed, "YYYY-MM-DD", true).isValid() && moment(funding.date_end, "YYYY-MM-DD", true).isValid();
                    })

                } else{
                    this.checkFinancings()
                }
            },
            addFinance() {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else{
                    this.fundings.push({
                        title: 'Modifică titlul finanțării',
                        infos: '',
                        contract_no: '',
                        date_signed: '',
                        date_started: '',
                        date_end: '',
                        total_project: '',
                        eligible_project: '',
                        eligible_ben: '',
                        support_ben: '',
                        cashback: '',
                        funding_source: '',
                        currency: '',
                        currency_rate: '',
                        currency_date: '',
                        opened: true,
                        type: 'sent'
                    })
                }
            },
            deleteFinance(key){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.fundings.splice(key, 1)
                }
            },
            sendForm() {
                if(this.notGranted){
                    this.$emit('finantariObtinute', {'fundingSent': [], 'fundingAsked': [], 'fundingNotGranted': true})
                }
                else{
                    if(this.fundings.length === 0){
                        this.completed = false
                        this.$toast.error('Te rugăm adaugă cel puțin o finanțare.');
                    }
                    else{
                        this.$refs.fundingSent.validate().then((e) => {
                            if (!e) {
                                this.completed = false
                                this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                            } else {
                                if(this.completed){
                                    this.$emit('finantariObtinute', {'fundingSent': this.fundingSent, 'fundingAsked': this.fundingAsked, 'fundingNotGranted': false, 'fundings': this.fundings})
                                }
                            }
                        })
                    }

                }
            },
            checkFinancings(){
                if(this.cui){
                    // M1
                    this.notGranted = true
                    if(this.stateAids.m1){
                        this.fundings.push({
                            title: 'Măsura 1 - Granturi pentru capital de lucru',
                            contract_no: this.stateAids.m1['Nr. RUE'] ? ('M1 - ' + this.stateAids.m1['Nr. RUE']) : '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: this.stateAids.m1.suma,
                            eligible_project: this.stateAids.m1.suma,
                            eligible_ben: '-',
                            support_ben:  this.stateAids.m1.suma,
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 130 / Guvernul României / POC AP 3',
                            currency: 'LEI',
                            currency_rate: '4.8395',
                            currency_date: 'Inforeur septembrie 2020',
                            opened: false,
                            type: 'sent',
                        })
                        this.notGranted = false
                    } else if(this.m3allData && this.m3allData.m3_project && this.m3allData.m3_project.state_aids && Number(this.m3allData.m3_project.state_aids.help_moneyM1) > 0) {
                        this.fundings.push({
                            title: 'Măsura 1 - Granturi pentru capital de lucru',
                            contract_no: '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: Number(this.m3allData.m3_project.state_aids.help_moneyM1),
                            eligible_project: Number(this.m3allData.m3_project.state_aids.help_moneyM1),
                            eligible_ben: '-',
                            support_ben:  Number(this.m3allData.m3_project.state_aids.help_moneyM1),
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 130 / Guvernul României / POC AP 3',
                            currency: 'LEI',
                            currency_rate: '4.8395',
                            currency_date: 'Inforeur septembrie 2020',
                            opened: false,
                            type: 'sent',
                        })
                        this.notGranted = false
                    }
                    //M2
                    /*this.getComunicateByCui(this.cui)*/
                    let ajutorM2 = this.stateAids.m2
                    if(ajutorM2) {
                        this.fundings.push({
                            title: 'Măsura 2 - Granturi pentru capital de lucru',
                            contract_no: ajutorM2['Nr. ordine'] ? 'M2 - '+ajutorM2['Nr. ordine'] : '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: ajutorM2['Suma solicitata'],
                            eligible_project: ajutorM2['Suma solicitata'],
                            eligible_ben: ((ajutorM2['Suma solicitata'] / 100) * 15).toFixed(0),
                            support_ben: ajutorM2['Suma solicitata'] - ((ajutorM2['Suma solicitata'] / 100) * 15).toFixed(0),
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 130 / Guvernul României / POC AP 3',
                            currency: 'LEI',
                            currency_rate: '4.8395',
                            currency_date: 'Inforeur septembrie 2020',
                            opened: false,
                            type: 'sent'
                        })
                        this.notGranted = false
                    } else if(this.m3allData && this.m3allData.m3_project && this.m3allData.m3_project.state_aids && Number(this.m3allData.m3_project.state_aids.help_moneyM2) > 0) {
                        this.fundings.push({
                            title: 'Măsura 2 - Granturi pentru capital de lucru',
                            contract_no: '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: Number(this.m3allData.m3_project.state_aids.help_moneyM2),
                            eligible_project: Number(this.m3allData.m3_project.state_aids.help_moneyM2),
                            eligible_ben: '-',
                            support_ben:  Number(this.m3allData.m3_project.state_aids.help_moneyM2),
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 130 / Guvernul României / POC AP 3',
                            currency: 'LEI',
                            currency_rate: '4.8395',
                            currency_date: 'Inforeur septembrie 2020',
                            opened: false,
                            type: 'sent',
                        })
                        this.notGranted = false
                    }

                    //HORECA
                    if(this.stateAids.horeca){
                        this.fundings.push({
                            title: 'HORECA - Sprijin financiar pentru îtreprinderile din domeniul HORECA',
                            contract_no: this.stateAids.horeca['Nr. ordine'] ? ('H - ' + this.stateAids.horeca['Nr. ordine']) : '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: this.stateAids.horeca['Suma solicitata'],
                            eligible_project: this.stateAids.horeca['Suma solicitata'],
                            eligible_ben: '-',
                            support_ben:  this.stateAids.horeca['Suma solicitata'],
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 224 / Guvernul României / Horeca',
                            currency: 'LEI',
                            currency_rate: '4.9260',
                            currency_date: 'Horeca 28 iunie 2021',
                            opened: false,
                            type: 'sent'
                        })
                        this.notGranted = false
                    } else if(this.m3allData && this.m3allData.m3_project && this.m3allData.m3_project.state_aids && Number(this.m3allData.m3_project.state_aids.help_moneyHoreca) > 0) {
                        this.fundings.push({
                            title: 'HORECA - Sprijin financiar pentru îtreprinderile din domeniul HORECA',
                            contract_no: '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: Number(this.m3allData.m3_project.state_aids.help_moneyHoreca),
                            eligible_project: Number(this.m3allData.m3_project.state_aids.help_moneyHoreca),
                            eligible_ben: '-',
                            support_ben:  Number(this.m3allData.m3_project.state_aids.help_moneyHoreca),
                            cashback: '100% nerambursabil',
                            funding_source: 'OUG 224 / Guvernul României / Horeca',
                            currency: 'LEI',
                            currency_rate: '4.9260',
                            currency_date: 'Horeca 28 iunie 2021',
                            opened: false,
                            type: 'sent'
                        })
                        this.notGranted = false
                    }

                    //IMM Invest
                    if(this.m3allData && this.m3allData.m3_project && this.m3allData.m3_project.state_aids && Number(this.m3allData.m3_project.state_aids.help_moneyIMM) > 0) {
                        this.fundings.push({
                            title: 'IMM INVEST - Ajutor de stat prin Fondul Naţional de Garantare a Creditelor pentru Întreprinderile Mici si Mijlocii',
                            contract_no: '',
                            date_signed: '',
                            date_started: '',
                            date_end: '',
                            total_project: Number(this.m3allData.m3_project.state_aids.help_moneyIMM),
                            eligible_project: Number(this.m3allData.m3_project.state_aids.help_moneyIMM),
                            eligible_ben: '',
                            support_ben:  Number(this.m3allData.m3_project.state_aids.help_moneyIMM),
                            cashback: '',
                            funding_source: '',
                            currency: 'LEI',
                            currency_rate: '',
                            currency_date: '',
                            opened: false,
                            type: 'sent'
                        })
                        this.notGranted = false
                    }

                /*if(this.fundingSent.length === 0)
                    this.addFinance('sent')
                if(this.fundingAsked.length === 0)
                    this.addFinance('asked')*/
                }
                if(this.fundings && this.fundings.length > 0){
                    this.fundings[0].opened = true
                }
            },
            getComunicateByCui(cui) {
                axios.get(api.API_ENDPOINTS.m3pressReleasesByCui + cui)
                    .then(response => {
                        if(response && response.data && response.data.data && response.data.data.agreement_accepted){
                            this.fundings.push({
                                title: 'Măsura 2 - Granturi pentru capital de lucru',
                                contract_no: response.data.data.rue_no ? ('M2 - ' + response.data.data.rue_no) : '',
                                date_signed: response.data.data.contract_signed ? response.data.data.contract_signed : '',
                                date_started: response.data.data.grant_received ? response.data.data.grant_received : '',
                                date_end: response.data.data.press_final_published ? response.data.data.press_final_published : '',
                                total_project: response.data.data.estimated_value && response.data.data.co_finance_value ? Number(Number(response.data.data.estimated_value) + Number(response.data.data.co_finance_value)).toFixed(2) : '',
                                eligible_project: response.data.data.estimated_value ? response.data.data.estimated_value : '',
                                eligible_ben: response.data.data.estimated_value ? Number(Number(response.data.data.estimated_value) * 0.15).toFixed(2) : '',
                                support_ben: Number(Number(response.data.data.estimated_value) + Number(response.data.data.co_finance_value)).toFixed(2) - Number(Number(response.data.data.estimated_value) * 0.15).toFixed(2),
                                cashback: '100% nerambursabil',
                                funding_source: 'OUG 130 / Guvernul României / POC AP 3',
                                currency: 'LEI',
                                currency_rate: '4.8395',
                                currency_date: 'Inforeur septembrie 2020',
                                opened: false,
                                type: 'sent'
                            })
                            this.notGranted = false
                        }
                    })
                    .catch (xhr => {
                        if(xhr)
                            console.log('No data found!')
                    })
            },
        }
    }
</script>

<style scoped>
.asistenta{
    margin: 30px 0;
    position: relative;
}
.asistenta-header{
    background: #e9eaec;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    margin-bottom: 20px;
}
.asistenta-header h3{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0;
    color: #767a95;
}
.asistenta-header .actions-buttons{
    display: flex;
    width: 100%;
    min-width: 130px;
    margin-right: 80px;
    max-width: 200px;
    align-items: center;
    justify-content: space-between;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
.asked-badge, .sent-badge, .action-badge{
    padding: 3px 10px;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    border-radius: 3px;
}
.asked-badge{
    background: #fae1cd;
    border: 1px solid #dcc7ad;
}
.sent-badge{
    background: #cdfaee;
    border: 1px solid #abddd7;
}
.move-button{
    background: #8b6a85 !important;
}
.move-button, .add-button{
    max-width: 255px !important;
}
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 44%;
}
.centered-radios{
    padding-left: 25%;
    margin: 45px 0;
}
.centered-radios >>> label{
    font-size: 14px;
    color: #767a95;
}
.asistenta-header >>> .expand-icon{
    stroke: #49cda8;
    cursor: pointer;
    fill: #49cda8;
    margin-right: 10px;
}
.asistenta-header >>> .delete-icon{
    fill: #ea8196;
    cursor: pointer;
}
</style>
